// import { firebaseAction } from 'vuexfire'
// import { formatDate, dateAdd } from '@/util'
import data from '@/data'
import u from '@/util'

const ref = data.db.ref('/persons')

const state = {
  cache: {}
}

// Enforce local cache of '/persons' child nodes
const listeners = {}

const mutations = {
  setPerson (state, { name, value }) {
    state.cache[name] = value
  },

  removePerson (state, name) {
    delete state.cache[name]
  }
}

const actions = {
  // bindPersonsRef: firebaseAction(({ bindFirebaseRef, unbindFirebaseRef }, { ref }) => {
  //   unbindFirebaseRef('cache')
  //   bindFirebaseRef('cache', ref)
  // }),
  addPerson (context, { name, value }) {
    return ref.child(name).set(value).then(() => {
      if (value && !listeners[name]) {
        listeners[name] = true
        ref.child(name).on('value', () => {})
      }
      context.commit('setPerson', { name, value })
    })
  },
  removePerson (context, name) {
    return ref.child(name).remove().then(() => {
      const value = state.cache[name]
      if (value && listeners[name]) {
        delete listeners[name]
        ref.child(name).off('value')
      }
      context.commit('removePerson', name)
    })
  },
  getByEmail (context, email) {
    return data.db.ref('/users').child(email.replace(/\./g, '*')).once('value',
      () => {},
      () => context.commit('error', u.error('No user with such email', email))
    ).then(snapshot => {
      const person = snapshot.val()
      if (!person) return null
      person.email = email
      return person
    })
    // return ref.orderByChild('email').equalTo(email).limitToFirst(1).once('value').then(snapshot => {
    //   const persons = snapshot.val()
    //   if (persons) {
    //     return Object.keys(persons).map(key => {
    //       const value = persons[key]
    //       context.commit('setPerson', { name: key, value })
    //       return value
    //     })[0]
    //   }
    //   return null
    // })
  }
}

export default { state, mutations, actions }
